import { getPacActions } from "@icg360/pac";
import getPolicyXml from "qandp/promises/get-policy-xml";

export default ({ apiQuotingUrl, featureFlags, policyId, serviceUrl }) =>
  Promise.all([
    getPacActions({ apiQuotingUrl, featureFlags, policyId }),
    getPolicyXml({ policyId, serviceUrl })
  ]);
